import React from 'react';
import { SectionShell } from './_shared';
import QuickBooksCard from '../integrations/QuickBooksCard';
import SyncLogSection from '../quickbooks/SyncLogSection';

/**
 * Phase 25 — Integrations tab.
 *
 * Phase 25.3 adds the publish-history log beneath the QuickBooks card +
 * mappings.
 */
export default function IntegrationsSection({ onToast }) {
  return (
    <SectionShell
      eyebrow="Phase 25"
      title="Integrations"
      description="Connect Clasifi to your accounting stack. We import your chart of accounts, vendors, tax codes, and payment accounts so you can map Clasifi categories once and sync forever."
      testid="settings-section-integrations"
    >
      <QuickBooksCard onToast={onToast} />
      <SyncLogSection onToast={onToast} />
    </SectionShell>
  );
}
